export const SUGAR_GREMLIN_TIME_ZONE = 'Pacific/Auckland' as const

export type PublishedMenuWeek = {
  startsOn: string
  endsOn: string
  timeZone: typeof SUGAR_GREMLIN_TIME_ZONE
}

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'] as const

function parseDateOnly(value: string) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
  if (!match) return null
  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const date = new Date(Date.UTC(year, month - 1, day))
  if (
    date.getUTCFullYear() !== year
    || date.getUTCMonth() !== month - 1
    || date.getUTCDate() !== day
  ) return null
  return { year, month, day }
}

function formatDateOnly(value: string) {
  const parsed = parseDateOnly(value)
  if (!parsed) return null
  return `${MONTHS[parsed.month - 1]} ${parsed.day}`
}

export function formatPublishedMenuDateRange(week: PublishedMenuWeek) {
  if (week.timeZone !== SUGAR_GREMLIN_TIME_ZONE) return null
  const start = formatDateOnly(week.startsOn)
  const end = formatDateOnly(week.endsOn)
  if (!start || !end) return null
  return `${start} – ${end}`
}
